module.exports = __webpack_public_path__ + "static/TWP_OrangeCounty_2019-67654d47064d6290683526403bc8480d.svg";